import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import axios, {  } from 'axios';
import {  Link } from 'react-router-dom';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import moment from 'moment';
import '../../App.css';
import paginationFactory, { PaginationProvider, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    if (value == null) return 'None';
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
function creditCurrencyFormat(num) {
    return '$' + (-1 * num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
class ViewCreditHistory extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            account: props.location.state.account,
            page: 1,
            data: [],
            totalSize: 0,
            searchTerm: '',
            sizePerPage: 20,
            selected: [],
            loading: false
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleDownloadSelected = this.handleDownloadSelected.bind(this);
        this.showButton = this.showButton.bind(this);

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);


        this.tableRef = React.createRef();
    }

    componentDidMount() {
        this.handleTableChange("None", this.state);
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleDownloadSelected}>
                Download Selected
            </Button>
        }
    }

    handleClear() {
        this.setState({
            searchTerm: '',
            page: 1
        }, function () {
            this.handleTableChange("None", { page: 1, sizePerPage: 10 });
        });
    }
    handleSearch(event) {
        event.preventDefault();
        this.state.page = 1;
            this.handleTableChange("None", this.state);
    }

    handleSearchChange(event) {
        this.setState({
            searchTerm: event.target.value
        });
    }

    handleSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                selected: [...this.state.selected, row]
            }));
        } else {
            this.setState(() => ({
                selected: this.state.selected.filter(x => x !== row)
            }));
        }
    }

    handleSelectAll = (isSelect, rows) => {
        if (isSelect) {
            this.setState(() => ({
                selected: rows
            }));
        } else {
            this.setState(() => ({
                selected: []
            }));
        }
    }


    handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        if (type == "pagination") {
            this.creditTableRef.current.selectionContext.selected = [];
            this.setState(() => ({
                selectedCredits: []
            }));
        }
        axios.get(`${Constants.apiURL}/api/Payment/payments`, {
            params: {
                username: this.state.user.username,
                accountID: this.state.account.accountID,
                type: 1,
                page: page,
                pageSize: sizePerPage,
                sortOrder: sortOrder,
                sortField: sortField,
                searchTerm: this.state.searchTerm,
                isHistory: true
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    data: JSON.parse(response.data.data),
                    totalSize: response.data.rowcount,
                    page: page,
                    sizePerPage: sizePerPage,
                    sortField: sortField,
                    sortOrder: sortOrder,
                    selectedCredits: [],
                    selectedCreditIds: []
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleDownloadSelected(event) {

        event.preventDefault();
        if (this.state.selected.length == 0) { return; }
        this.setState({ loading: true });
        let creditNumbers = this.state.selected.reduce(function (str, item) {
            return str + item.PaymentNumber + ",";
        }, '');
        axios.get(`${Constants.apiURL}/api/Payment/downloadCredits`, {
            params: {
                user: this.state.user.username,
                documentNumbers: creditNumbers
            },
            responseType: "blob"
        }).then(response => {

            this.setState({ loading: false });
            ReactGA.event({
                category: 'Download',
                action: 'Closed Credit Download',
                label: 'Credit History - Download Credit'
            });

            let blob = new Blob([response.data], { type: "application/zip" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            else {
                alert('We are unable to locate the selected document(s). Please email us at AR@boland.com for help with this issue.');
                return;
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    render() {
        const { data, totalSize, page, sizePerPage, selected } = this.state;
        const creditColumns = [
            {
                dataField: 'PaymentNumber',
                text: 'Credit #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'CreatedOn',
                text: 'Credit Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OriginatingAmount',
                text: 'Total Credit Amount',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: creditCurrencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceAmount',
                text: 'Credit Balance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            }
        ];
        const selectCreditRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        const pagination = {
            custom: true,
            totalSize: totalSize,
            page: page,
            sizePerPage: sizePerPage
        };

        return (
            <div class="open_invoices">
                <SiteMenu user={this.state.user} currentPage='creditHistory' />
                <Form onSubmit={this.handleSearch} className="mb-3">
                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 15px 0px 15px' }}>

                        <Col md={4} >
                            <Form.Control ref={this.filterText} value={this.state.searchTerm} type="input" size="sm" onChange={this.handleSearchChange} placeholder="Search by credit number..." />
                        </Col>
                        <Col md="auto" style={{ paddingLeft: 0, paddingRight: 0 }} >
                            <Button size="sm" style={{ width: 'auto', backgroundColor: '#1F419B' }} type="submit" >Search</Button>
                        </Col>
                        <Col md="auto" >
                            <Button size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                        </Col>
                        <Col width='100%' />
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.account.accountID} | {this.state.account.accountName}</Form.Label>
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            <Button as={Link} to={{
                                pathname: "/open_invoices",
                                state: {
                                    user: this.state.user,
                                    account: this.state.account
                                }
                            }}  style={{ backgroundColor: '#00973A' }} size="sm">
                                View Open Invoices / Credits
                            </Button>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 15px 0px 15px' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>CREDIT HISTORY</Form.Label>
                            <br/>
                            <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', paddingLeft: '0px', fontStyle: 'italic' }}>Below are credits and returns that have already been refunded or applied towards invoice payment. For information on how these documents have been applied, please contact AR@boland.com.</Form.Label>                            
                        </Col>
                    </Form.Group>
                </Form>
                <PaginationProvider pagination={paginationFactory(pagination)}>
                    {({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <div>
                            <BootstrapTable
                                remote
                                id="open_invoices_table"
                                keyField="PaymentKey"
                                wrapperClasses="table-responsive"
                                data={data}
                                columns={creditColumns}
                                onTableChange={this.handleTableChange}
                                selectRow={selectCreditRow}
                                noDataIndication={() => <Form.Label>No credit history.</Form.Label>}
                                hover
                                ref={this.tableRef}
                                {...paginationTableProps}
                            />
                            <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 0px 10px', marginRight: 0 }}>

                                <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 10 }}>
                                    {this.showButton()}
                                </Col>
                                <Col width='100%' />
                                <Col md="auto" sm="auto" xs="auto"
                                    style={{ paddingRight: '10px' }} >
                                    <PaginationListStandalone
                                        {...paginationProps}
                                    />
                                </Col>
                            </Form.Group>
                        </div>
                    )
                    }
                </PaginationProvider>
            </div>
        );
    }
}

export default ViewCreditHistory;